import "./index.scss";
type NewSectionList = {
  title: string;
  body: string;
};

const newSectionList: NewSectionList[] = [
  {
    title: "Hydrogen VS electric Cars",
    body: "Will hydrogen- huelfed cars ever catch up to EVs?",
  },
  {
    title: "The Downsides of AI Artistry",
    body: "What are the possbiel adverse effects of on-demand AI image generation?",
  },
  {
    title: "Is VC Funding Dying Up?",
    body: "Private funding by VC firms is down 50% YOY. We take a look at what that means.",
  },
];

export default function NewSection() {
  return (
    <div className="new">
      <span className="new__title">New</span>

      <div className="new__list__wrapper">
        {newSectionList.map(({ title, body }, index) => {
          return (
            <div key={`${index}wrapper`}>
              <span className="new__list__wrapper__title">{title}</span>
              <p className="new__list__wrapper__body">{body}</p>
              {index !== newSectionList.length - 1 ? (
                <div className="new__list__wrapper__divider"></div>
              ) : null}
            </div>
          );
        })}
      </div>
    </div>
  );
}
